//const baseurl = (process.env.NODE_ENV === 'production' ? 'https://webappscrabbleclub.azurewebsites.net/api/Values' : 'https://localhost:55557/api/Values');
const baseurl = 'https://webappscrabbleclub.azurewebsites.net/api/Values';

async function typicalCall(url) {
    let responseText = "";
    try {
        let response = await fetch(url);
        responseText = await response.text();
        const jdata = JSON.parse(responseText);
        jdata.value.error = false;
        return jdata.value;
    } catch (error) {
        console.log(url);
        console.log(responseText);
        return {error: responseText};
    }
}

async function binaryResultCall(url) {
    let responseText = "";
    try {
        let response = await fetch(url);
        responseText = await response.text();
        const jdata = JSON.parse(responseText);
        return jdata.value;
    } catch (error) {
        console.log(url);
        console.log(responseText);
        return {error: responseText};
    }
}

/**
 * Get the pairs of six letter words that use the twelve passes letters
 * @param {lexicon} lexicon e.g. NWL2023
 * @param {letters} letters The 12 letters to get sixpacks from (pairs of 6 letter words using those 12 letters)
 * @returns Array of pairs of six letter words using the passed twelve letters
 * @async
 */
export async function getSixpacks(lexicon, letters) {
    let url = `${baseurl}/${lexicon}/sixpacks?letters=${letters}`;
    let response = typicalCall(url);
    return response;
}

/**
 * Check whether a word is in a lexicon
 * @param {lexicon} lexicon Lexicon, e.g. NWL2023
 * @param {word} word Word to check
 * @returns Whether the word is in the lexicon
 */
export async function wordExists(lexicon, word) {
    let url = `${baseurl}/${lexicon}/exists?word=${word}`;
    let response = await binaryResultCall(url);
    return response;
}